import StitchService from '@/services/api/StitchService';

const state = {
  allStitches: []
};

const getters = {
  allStitches: state => state.allStitches
};

const actions = {

  async updateAllStitches ({ commit }, {type, outfitId }) {
    if (type === "add") {
      commit('ADD_STITCHES', [outfitId]);

    } else if (type === "remove") {
      commit('REMOVE_STITCH', outfitId);
    }
  },

  async fetchAllStitches({ commit }) {
    return StitchService.getAll()
      .then((response) => {
        const outfitIds = response.data.stitches.map(s => s.outfit_id)

        commit('ADD_STITCHES', outfitIds);
      })
      .catch(error => {
        // commit('SAVE_ERROR_RESPONSE', error.message);
      })
  },

  async resetAllStitches({ commit }) {
    commit('RESET_ALL_STITCHES');
  }
};

const mutations = {
  ADD_STITCHES(state, ids) {
    const stitches = new Set([...state.allStitches, ...ids]);

    state.allStitches = [...stitches]
  },

  REMOVE_STITCH(state, id) {
    const stitches = new Set([...state.allStitches])
    stitches.delete(id)

    state.allStitches = [...stitches]
  },

  RESET_ALL_STITCHES(state) {
    state.allStitches = [];
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/stitch/index.js